import { c as _c } from "react/compiler-runtime";
import type { FilePopulated } from "@vita-learning/types";
import type { FC } from "react";
interface FileItemProps {
  readonly file: FilePopulated;
}
export const FileItem: FC<FileItemProps> = t0 => {
  const $ = _c(2);
  const {
    file
  } = t0;
  let t1;
  if ($[0] !== file.title) {
    t1 = <div className="file-item"><h4>{file.title}</h4></div>;
    $[0] = file.title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};